import styled from "styled-components";

export const FormPageWrapper = styled.div`
  display: grid;
  height: 100vh;
  width: 100vw;
  justify-items: center;
  align-items: center;
  background-color: #027afe;
`